module.exports = __webpack_public_path__ + "3aef7cd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/media_appledaily.png
// module id = 1682
// module chunks = 0